export enum ConsentCategory {
  Necessary = 'necessary',
  Functional = 'functional',
  Analytics = 'analytics',
  Performance = 'performance',
  Advertisement = 'advertisement',
  Other = 'other',
}
